import React, { memo, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { NavbarTop, Devtools } from './portals';
import { ToolBox } from "./comps/DevTools";

import "./App.css";
import "./styles/datatable.scss";
import "./styles/buttonColor.css";
import "./styles/overrides.scss";
import { InitPermission } from "@redux-action/permissions/permissions";
//  HL: Replace BrowserRouter with Router make history work correctly
import { Route, Switch } from 'react-router-dom';
import { Router } from 'react-router';
import { connect } from 'react-redux';

import PrivateRoute from './routes/PrivateRoute';

import ErrorBoundary from './comps/ErrorBoundary';
import ConfirmModal from './comps/Modals/ConfirmModal';

import SideBar from './comps/SideBar';
import Navbar from './comps/Navbar';
import Bootstrap, { socket } from './helpers/bootstrap';
Bootstrap();
import { history } from "./redux-store/store";
import Spinner from "./comps/Spinner";
import { setAlert } from "@redux-action/alert";

import RequestPasswordReset from "./views/Auth/RequestPasswordReset";
import ResetPassword from "./views/Auth/ResetPassword";
import ReduxConfirmModal from "@comps/ReduxConfirmModal/Modal";

import useTrackPreviousLocation from './hooks/useTrackPreviousLocation';

const App = memo(
    ({ InitPermission, COMPONENT, loadingUserPermission, setAlert }) => {
        const [componentLoading, setComponentLoading] = useState(true);
        const isMounted = useRef(false);

        useEffect(() => {
            async function initApp() {
                if (!isMounted.current && isReactRoute()) {
                    isMounted.current = true;
                    return;
                }
                let component = getComponentViaUrl();
                await InitPermission({ component });
            }

            initApp()
                .then(() => console.debug('[App Initiated]'))
                .catch(() => console.debug('[App Failed to Initiate]'))
                .then(() => {
                    setComponentLoading(false);
                });
            subscribe();
            return () => cleanUp();
        }, [COMPONENT]);

        const subscribe = () => {
            //  Init event listener
            socket.on('broadcast', payload => {
                setAlert(payload.msg, payload.msgType, null);
            });
        };

        const cleanUp = () => {
            //  un-listening to broadcast
            unsubscribe();
            //  put component back in loading state
            setComponentLoading(true);
        };
        const unsubscribe = () => {
            socket.removeEventListener('broadcast');
        };

        return (
        /**
             * @param store --- Redux global state ---
             */

            <Router history={history}>
                <ErrorBoundary>
                    <NavbarTop>
                        {!loadingUserPermission && (
                            <Navbar
                                COMPONENT={
                                    COMPONENT || getComponentViaUrl()
                                }
                            />
                        )}
                    </NavbarTop>
                    <Devtools>
                        <ToolBox />
                    </Devtools>
                    <Switch>
                        <Route
                            exact
                            path={"/password-reset"}
                            component={RequestPasswordReset}
                        />
                        <Route
                            path={"/password-reset/:resetToken"}
                            component={ResetPassword}
                        />
                        <Route
                            path="/app"
                            render={props => (
                                <SubRoutes
                                    loadingUserPermission={
                                        loadingUserPermission
                                    }
                                    componentLoading={componentLoading}
                                    {...props}
                                />
                            )}
                        />
                    </Switch>
                </ErrorBoundary>
            </Router>
        );
    }
);

App.propTypes = {
    InitPermission: PropTypes.func.isRequired,
    COMPONENT: PropTypes.string,
    loadingUserPermission: PropTypes.bool.isRequired
};

const SubRoutes = props => {
    const { match, componentLoading } = props;
    useTrackPreviousLocation();

    if (componentLoading) {
        return <Spinner />;
    }

    return (
        <div className={`row`} id="">
            <ConfirmModal {...props} />
            <div className={'col-md-12'}>
                <Switch>
                    <PrivateRoute
                        path={`${match.path}/:component/:verb?/:id?/:secondid?/:thirdid?`}
                    />
                </Switch>
            </div>
            <ReduxConfirmModal />
            <SideBar />
        </div>
    );
};
const mapStateToProps = state => ({
    COMPONENT: state.MISC.APP.ROUTE.component,
    loadingUserPermission: state.permissions.loadingUserPermission
});
export default connect(mapStateToProps, {
    InitPermission,
    setAlert

})(App);

function getComponentViaUrl() {
    let component = history.location.pathname.split('/')[1];
    if (history.location.pathname.startsWith('/app/')) {
        document.querySelector('.notifications').style.display = 'none';
        component = history.location.pathname.split('/')[2];
    }
    return component;
}
function isReactRoute() {
    return history.location.pathname.startsWith("/app/");
}
